import { createSlice } from "@reduxjs/toolkit";
import client from "../../utils/api";
import { createApiAction } from "../../utils/redux-tool";

const name = "application-records";
const initialState = {
  list: null,
  recordsLoading: false,
  count: null,
  query: {
    que: null,
    limit: 10,
    offset: 0,
    yearApp: null,
    gradeApp: null,
    status: null,
    schoolId: null,
    formStatus: null,
    fileStatus: null
  },
  instance: null,
  instanceLoading: false,
  error: null,

};

export const search = createApiAction(
  "application/search",
  client.search("/api/application/student")
);

export const save = createApiAction(
  "application/save",
  client.save("/api/application/student")
);

export const get = createApiAction(
  "application/get",
  client.retrieve(`/api/application/student/:id`)
);

export const getSiblingInfo = createApiAction(
  "application/sibling-info/get",
  client.retrieve(`/api/application/student/:id/sibling-check`)
);

export const getParentEmploymentInfo = createApiAction("application/parent-employment/get", client.retrieve('/api/application/student/:id/staff-check'))

export const saveSchool = createApiAction(
  "application/school/save",
  client.save("/api/application/school")
);

const updateApplication = (state, action) => {
  const updatedItem = action.payload;
  if (!updatedItem || typeof updatedItem !== "object") return;

  if (!Array.isArray(state.list)) {
    state.list = [];
  }

  const existingIndex = state.list.findIndex((item) => item.id === updatedItem.id);
  if (existingIndex !== -1) {
    const existingSchools = state.list[existingIndex].applicationSchools || [];

    let mergedApplicationSchools = existingSchools;
    if (Array.isArray(updatedItem.applicationSchools)) {
      mergedApplicationSchools = updatedItem.applicationSchools.map((updatedSchool) => {
        const existingSchool = existingSchools.find(
          (es) => es.id === updatedSchool.id || es.schoolId === updatedSchool.schoolId
        );
        if (existingSchool) {
          return {
            ...existingSchool,
            ...updatedSchool,
            school: updatedSchool.school || existingSchool.school,
          };
        }
        return updatedSchool;
      });
    }

    state.list[existingIndex] = {
      ...state.list[existingIndex],
      ...updatedItem,
      address: {
        ...(state.list[existingIndex].address || {}),
        ...(updatedItem.address || {}),
      },
      academicYearProvider: {
        ...(state.list[existingIndex].academicYearProvider || {}),
        ...(updatedItem.academicYearProvider || {}),
      },
      studentGr: {
        ...(state.list[existingIndex].studentGr || {}),
        ...(updatedItem.studentGr || {}),
      },
      applicationSchools: mergedApplicationSchools,
    };
  } else {
    state.list.push({
      ...updatedItem,
    });
  }
};

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    setSearchApplicationQuery: (state, action) => {
      state.query = action.payload;
    },
    resetSearchApplicationQuery: (state) => {
      state.query = initialState.query;
    },
    setSearchApplicationLimit: (state, action) => {
      state.query.limit = action.payload;
    },
    setSearchApplicationOffset: (state, action) => {
      state.query.offset = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.pending, (state) => {
        state.list = null;
        state.recordsLoading = true;
      })
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload.rows;
        state.count = action.payload.count;
        state.recordsLoading = false
      })
      .addCase(get.pending, (state) => {
        state.instanceLoading = true;
        state.error = null;
      })
      .addCase(get.rejected, (state) => {
        state.instanceLoading = false;
      })
      .addCase(get.fulfilled, (state, action) => {
        state.instanceLoading = false;
        state.instance = action.payload;
      })
      .addCase(save.fulfilled, updateApplication)
      .addCase(saveSchool.fulfilled, updateApplication)

  },
});

export const {
  setSearchApplicationQuery,
  setSearchApplicationLimit,
  setSearchApplicationOffset,
  resetSearchApplicationQuery
} = sessionSlice.actions;

export default sessionSlice.reducer;
